module.exports = __webpack_public_path__ + "static/media/2-F.c61d29c5.webp";